import { FormApi } from 'final-form';
import { IAccount } from 'store/accounts.model';
import { IApiResponse } from 'utils/models';

export interface ISSNITPaymentsState {
  accounts: IAccount[];
  currency: string;
}

export type IFormValues = {
  adviceNumber: string;
  customerName: string;
  customerCode: string;
  contributionType: string;
  contributionAmount: string;
  penaltyAmount: string;
  payAmount: string;
  establishmentName: string;
  receiptId: string;
  adviceReference: string;
  adviceDate?: string;
  narration: string;
  sourceAccount: string;
};

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export interface IResponseVerifyData {
  totalContributionAmount: string;
  totalPenaltyAmount: string;
  totalAmountToPay: string;
  nameOfEstablishment: string;
  receiptID: string;
  paymentAdviceReference: string;
  paymentAdviceDate: string;
}

export enum Steps {
  VERIFY = 'VERIFY',
  FIRST_PROCEED = 'FIRST_PROCEED',
  SECOND_PROCEED = 'SECOND_PROCEED',
}

export interface IGetVerifyResponse extends IApiResponse {
  response: IResponseVerifyData;
}

export interface IPaySSNIT {
  paymentAdviceNumber: string;
  customerName: string;
  customerCode: string;
  contributionType: string;
  sourceAccount: string;
  amount: number;
  currency: string;
  narration: string;
  passwordType: string;
  password: string;
  transType: string;
}
